<script lang="ts">
	import { Button } from '$lib/components/ui/button';
	import * as Sidebar from '$lib/components/ui/sidebar/index';
	import { Heart } from 'lucide-svelte';

	let { storyTitle } = $props<{ storyTitle: string }>();
	let isFavorited = $state(false);

	function toggleFavorite() {
		isFavorited = !isFavorited;
		// TODO: Implement favorite functionality
	}
</script>

<header class="w-full border-b px-2 py-2 md:py-3">
	<div class="flex items-center justify-between">
		<Sidebar.Trigger />

		<h1
			class="max-w-[60%] truncate text-center text-sm font-semibold text-primary md:text-base lg:text-lg"
		>
			{storyTitle}
		</h1>

		<Button variant="ghost" size="icon" aria-label="Toggle favorite" onclick={toggleFavorite}>
			<Heart class="h-5 w-5" fill={isFavorited ? 'currentColor' : 'none'} />
		</Button>
	</div>
</header>
